/* eslint-disable no-dupe-keys */
export default {
  pickup_location: {
    name: '商品提货点',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '地点名称',
      city: '城市',
      address: '地址',
      full_address: '详细地址',
      longitude: '经度',
      latitude: '纬度',
      phone: '联系电话',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      name: '地点名称',
      city: '城市名',
      address: '地址',
      full_address: '详细地址',
      longitude: '经度',
      latitude: '纬度',
      phone: '联系电话',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      enabled: '可用',
      disabled: '不可用'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询地点名称/地址/联系电话'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      location: '定位'
    }
  }
}
